import React, {useCallback, useEffect, useRef, useState} from 'react';
import {TextInput, View} from 'react-native';
import {
  invitationApplyColor,
  shareBg,
  newLogo,
  signUpGetGiftsBg,
  regDownloadBtn,
} from './invitation.variables';
// import ImageBackgroundBasic from './ImageBackgroundBasic';
import Text from '@basicComponents/text';
// import LinearGradient from '@basicComponents/linear-gradient';
import {BasicObject, SafeAny} from '@/types';
import styles from './index.module.scss';

import {
  basicColor,
  borderRadius,
  flex,
  fontSize,
  margin,
  padding,
  position,
} from '@/components/style';
import LazyImage from '@/components/basic/image';
import {PhoneIcon, SaveIcon} from './svg.variables';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {sendCode, userLogin} from '../login/login.service';
import globalStore from '@/services/global.state';
import i18n from '@/i18n';
import baseVariable from '@/style/base.variable';
import {downloadApk, inApp, useResponsiveDimensions} from '@/utils';
import theme from '@/style';
import {Image} from 'antd-mobile';
import {clearRechargeGiftAccountStorage} from '@/pages/home/components/recharge-gift/recharge-gift-storage';
import {ProgressiveCircularLoading} from '@fe-progressive/package-progressive/progressive-loading';
import {validateInviteCode} from './invitation.service';
import {useConfirm} from '@/components/basic/modal';
// import { Button } from 'antd-mobile';
const outline: SafeAny = {
  outline: 0,
};
const InvitationApply = (props: SafeAny) => {
  const [userPhone, setUserPhone] = useState('');
  const [OTPCode, setOTPCode] = useState('');
  const OTPTimeRef = useRef(59);
  const [OTPTime, setOTPTime] = useState(59);
  const [hasOTP, setOTP] = useState(false);
  const [OTPLoading, setOTPLoading] = React.useState(false);
  const {route} = props;
  const [invitaCode, setInvitaCode] = useState(
    (route.params as BasicObject)?.code || '',
  );
  const invitaCodeRef = useRef(invitaCode);
  useEffect(() => {
    invitaCodeRef.current = invitaCode;
  }, [invitaCode]);
  const [inviteCodeValid, setInviteCodeValid] = useState(true);

  const clearInvalidInviteCode = useCallback(() => {
    setInvitaCode('');
    invitaCodeRef.current = '';
    setInviteCodeValid(true);
    localStorage.removeItem('invitationCode');
  }, []);

  const {renderModal: renderInvalidCodeModal, show: showInvalidCodeModal} =
    useConfirm(undefined, undefined, {
      variant: 'error',
      duration: 5000,
      closeOnClick: true,
    });
  const {width: screenWidth, height: screenHeight} = useResponsiveDimensions();
  const setHasOTP = () => {
    setOTP(true);
    OTPTimeRef.current = 59;
    setOTPTime(OTPTimeRef.current);
  };
  useEffect(() => {
    const timer = setInterval(function () {
      if (hasOTP && OTPTimeRef.current > 1) {
        setTimeout(() => {
          OTPTimeRef.current = OTPTimeRef.current - 1;
          setOTPTime(OTPTimeRef.current);
        }, 1000);
      } else {
        clearInterval(timer);
        setOTP(false);
      }
    }, 1000);
    return () => {
      timer && clearInterval(timer);
    };
  }, [hasOTP]);
  const fromBgSize = React.useMemo(() => {
    const contentWidth = screenWidth - theme.paddingSize.l * 2;
    const formHeight = (contentWidth / 702) * 728;
    const innerWidth = contentWidth - theme.paddingSize.l * 2;
    const buttonWidth = innerWidth - theme.paddingSize.s * 2;
    const buttonHeight = (buttonWidth / 606) * 96;
    const scale = screenWidth / 350;
    // 背景图 share-bg.webp: 750x1624
    const bgHeight = (screenWidth / 750) * 1624;
    // Logo logo.webp: 532x98，按屏幕宽度比例计算
    const logoWidth = (screenWidth * 266) / 375; // 约47%的屏幕宽度
    const logoHeight = (logoWidth / 532) * 98;
    // 输入框距离顶部位置：91-120px之间（根据屏幕尺寸响应式计算）
    // 使用屏幕宽度的比例，但限制在91-120px范围内
    const inputTopOffset = (screenWidth / 375) * 105;

    return {
      formBox: {
        width: contentWidth,
        height: formHeight,
      },
      button: {
        width: buttonWidth,
        height: buttonHeight,
      },
      input: {
        height: scale * 48,
      },
      contentPadding: {
        paddingHorizontal: theme.paddingSize.l,
        paddingVertical: theme.paddingSize.l,
      },
      bgHeight,
      logo: {
        width: logoWidth,
        height: logoHeight,
      },
      inputTopOffset,
    };
  }, [screenWidth]);

  useEffect(() => {
    const code = (invitaCode || '').trim();
    if (!code) {
      setInviteCodeValid(true);
      return;
    }

    validateInviteCode(code)
      .then(result => {
        const valid = result?.valid === true || result?.status === 'VALID';
        if (!valid) {
          showInvalidCodeModal(
            'Binding failed',
            result?.message || 'Incorrect verification code',
            undefined,
            undefined,
            true,
          );
          clearInvalidInviteCode();
        } else {
          setInviteCodeValid(true);
        }
      })
      .catch(() => null);
  }, [invitaCode, showInvalidCodeModal, clearInvalidInviteCode]);

  const validateBeforeRegister = async (): Promise<boolean> => {
    const code = (invitaCodeRef.current || '').trim();
    if (!code) {
      return true;
    }

    const result = await validateInviteCode(code).catch(() => null);
    const valid = result?.valid === true || result?.status === 'VALID';
    if (!valid) {
      showInvalidCodeModal(
        'Binding failed',
        result?.message || 'Incorrect verification code',
        undefined,
        undefined,
        true,
      );
      clearInvalidInviteCode();
      return false;
    }
    return true;
  };

  return (
    // 背景图bg

    <View style={[theme.position.rel, {height: screenHeight}]}>
      {/*  */}
      {/* 背景和 logo 部分 */}
      <div
        className={styles.bg}
        style={{
          backgroundImage: `url(${shareBg})`,
          height: fromBgSize.bgHeight,
          backgroundSize: 'cover',
        }}>
        <div className={styles.logoContainer}>
          <Image
            src={newLogo}
            style={{
              width: fromBgSize.logo.width,
              height: fromBgSize.logo.height,
            }}
          />
        </div>
      </div>
      {/* <div>

      </div> */}
      {/* <ImageBackgroundBasic Img={topone} /> */}
      {/* <ImageBackgroundBasic Img={toptwo} />
      <ImageBackgroundBasic Img={content} />
      <ImageBackgroundBasic Img={bottom} /> */}
      <View
        style={[
          position.abs,
          {
            paddingBottom: theme.paddingSize.l * 2,
            bottom: theme.paddingSize.l * 2,
          },
          theme.fill.fillW,
          padding.lrl,
        ]}>
        <LazyImage
          imageUrl={signUpGetGiftsBg}
          occupancy="#0000"
          width={'100%'}
          height={fromBgSize.formBox.height}
        />
        <View style={[position.abs, fromBgSize.formBox]}>
          <View
            style={[
              theme.flex.flex1,
              {
                paddingTop: fromBgSize.inputTopOffset,
              },
            ]}>
            <View
              style={[fromBgSize.contentPadding, margin.lrs, theme.flex.flex1]}>
              <View>
                <View
                  style={[
                    // eslint-disable-next-line react-native/no-inline-styles
                    {
                      height: fromBgSize.input.height,
                      borderWidth: 1,
                      borderColor: invitationApplyColor.borderColor,
                      backgroundColor: invitationApplyColor.backgroundColor,
                    },
                    padding.lrl,
                    theme.fill.fillW,
                    borderRadius.m,
                    flex.row,
                    flex.centerByCol,
                  ]}>
                  <PhoneIcon width={24} height={24} />
                  <TextInput
                    placeholder="Phone number"
                    style={[
                      // eslint-disable-next-line react-native/no-inline-styles
                      {
                        height: fromBgSize.input.height,
                        marginLeft: 16,
                        borderWidth: 0,
                        borderColor: 'none',
                      },
                      flex.flex1,
                      outline,
                    ]}
                    value={userPhone}
                    maxLength={10}
                    placeholderTextColor={baseVariable.fontColor.secAccent}
                    onChange={(e: SafeAny) => setUserPhone(e.target.value)}
                  />
                </View>
                <View
                  style={[
                    // eslint-disable-next-line react-native/no-inline-styles
                    {
                      height: fromBgSize.input.height,
                      borderWidth: 1,
                      borderColor: invitationApplyColor.borderColor,
                      backgroundColor: invitationApplyColor.backgroundColor,
                    },
                    padding.lrl,
                    theme.fill.fillW,
                    borderRadius.m,
                    flex.row,
                    flex.centerByCol,
                    margin.topl,
                  ]}>
                  <SaveIcon width={24} height={24} />
                  <TextInput
                    placeholder="OTP"
                    underlineColorAndroid={'transparent'}
                    style={[
                      // eslint-disable-next-line react-native/no-inline-styles
                      {
                        height: fromBgSize.input.height / 2,
                        marginLeft: 16,
                        borderWidth: 0,
                        borderColor: 'none',
                        fontSize: 15,
                      },
                      flex.flex1,
                      outline,
                    ]}
                    value={OTPCode}
                    maxLength={6}
                    placeholderTextColor={baseVariable.fontColor.secAccent}
                    onChangeText={value => {
                      if (value) {
                        if (/^[0-9]+$/.test(value)) {
                          setOTPCode(value);
                        } else {
                          setOTPCode(OTPCode || '');
                        }
                      } else {
                        setOTPCode('');
                      }
                    }}
                  />
                  {hasOTP ? (
                    <Text
                      fontSize={fontSize.s}
                      accent
                      style={{
                        lineHeight: fontSize.s,
                      }}
                      textAlign="center"
                      blod>
                      {OTPTime}s
                    </Text>
                  ) : (
                    <NativeTouchableOpacity
                      onPress={() => {
                        if (!userPhone) {
                          return;
                        }
                        if (OTPLoading) {
                          return;
                        }
                        setOTPLoading(true);
                        sendCode(userPhone)
                          .then(() => {
                            setHasOTP();
                            globalStore.globalTotal.next({
                              type: 'success',
                              message: i18n.t('tip.success'),
                            });
                          })
                          .finally(() => setOTPLoading(false));
                      }}>
                      {OTPLoading ? (
                        <ProgressiveCircularLoading
                          size={20}
                          color={basicColor.red}
                        />
                      ) : (
                        <Text
                          color={basicColor.red}
                          fontSize={15}
                          fontWeight="bold">
                          Send
                        </Text>
                      )}
                    </NativeTouchableOpacity>
                  )}
                </View>
              </View>
              <View style={[margin.topl, flex.centerByRow]}>
                <NativeTouchableOpacity
                  disabled={!inviteCodeValid || OTPLoading}
                  onPress={async () => {
                    if (OTPLoading) {
                      return;
                    }
                    if (!userPhone || !OTPCode) {
                      return;
                    }
                    if (!(await validateBeforeRegister())) {
                      return;
                    }
                    globalStore.globalLoading.next(true);
                    userLogin(userPhone, OTPCode, invitaCodeRef.current)
                      .then((res: SafeAny) => {
                        globalStore.globalTotal.next({
                          type: 'success',
                          message: i18n.t('tip.success'),
                        });
                        clearRechargeGiftAccountStorage();
                        globalStore.token = res.token;
                        if (inApp) {
                          window.location.href = 'index/home';
                          return;
                        }
                        downloadApk();
                      })
                      .finally(() => globalStore.globalLoading.next(false));
                  }}>
                  <LazyImage
                    imageUrl={regDownloadBtn}
                    occupancy="#0000"
                    width={fromBgSize.button.width}
                    height={fromBgSize.button.height}
                  />
                </NativeTouchableOpacity>
              </View>
              <Text
                accent
                size="small"
                calc
                textAlign="center"
                style={[margin.tops, {marginTop: theme.paddingSize.s}]}>
                {i18n.t('referral.tip.desc')}
              </Text>
            </View>
          </View>
        </View>
      </View>
      {renderInvalidCodeModal}
    </View>
  );
};

export default InvitationApply;
